import { useEffect, useMemo, useState } from "react";
import { useMatch } from "react-router-dom";
import { observer } from "mobx-react-lite";

import { BOT_ROUTE } from "@/app/constants/routes";
import { getCEXBots } from "@/shared/api/endpoints";
import { useQueryParams } from "@/shared/hooks/use-query-params";
import { CEXRoutes, getBotLink } from "@/shared/routing";

import { BreadCrumbSelectItem } from "../bread-crumb-select-item";
import { BreadCrumbItemProps, MenuItem } from "../types";

interface Bot {
	uuid: string;
	name: string;
}

const useGetCEXBotsList = () => {
	const [bots, setBots] = useState<Bot[]>([]);
	const query = useQueryParams().toString();
	const route = useMatch(BOT_ROUTE);
	const { section: currentBotSection, partyUUID } = route?.params || {};
	const newQuery = query ? `?${query}` : "";

	useEffect(() => {
		if (!partyUUID) return;

		getCEXBots(partyUUID).then(({ isError, data }) => {
			if (isError) return;

			const botsUUIDs = data.arrayBots.map(({ bot_uuid, name }: any) => ({ name, uuid: bot_uuid }));
			setBots(botsUUIDs);
		});
	}, [partyUUID]);

	const menuList = useMemo(
		(): MenuItem[] =>
			bots.map(({ name, uuid }) => {
				const botLink = getBotLink({
					partyUUID: partyUUID || "",
					botType: "CEX",
					uuid,
					botTab: currentBotSection as CEXRoutes,
				});

				return { value: uuid, label: name, redirectPath: `${botLink}${newQuery}` };
			}),
		[bots, currentBotSection, newQuery, partyUUID]
	);

	return menuList;
};

export const CEXBotBreadCrumb = observer(({ route, paths }: BreadCrumbItemProps) => {
	const menuList = useGetCEXBotsList();

	return (
		<BreadCrumbSelectItem route={route} paths={paths} menuList={menuList} popoverWidth={300} />
	);
});
